/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { Box, Flex, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export type Benefit = {
	icon: React.JSX.Element;
	iconBackgroundStyles: ReturnType<typeof xcss>;
	title: string;
	description: string;
};

type BenefitsListProps = {
	benefits: Benefit[];
};
export function BenefitsList(props: BenefitsListProps) {
	const { benefits } = props;
	return (
		<>
			<ul css={BenefitsListStyles}>
				{benefits.map((benefit, index) => (
					<li key={index} css={BenefitsListItemStyles}>
						<Flex key={benefit.title}>
							<Box xcss={[IconStyles, benefit.iconBackgroundStyles]}>{benefit.icon}</Box>
							<Box xcss={BenefitTextStyles}>
								<Inline xcss={TitleStyles}>{benefit.title}</Inline>
								<span>{benefit.description}</span>
							</Box>
						</Flex>
					</li>
				))}
			</ul>
		</>
	);
}

const IconStyles = xcss({
	color: 'color.text.selected',
	borderRadius: 'border.radius.circle',
	display: 'flex',
	width: '40px',
	height: '40px',
	justifyContent: 'center',
	alignItems: 'center',
	flexShrink: '0',
});

const BenefitTextStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	marginLeft: 'space.200',
});

const TitleStyles = xcss({
	fontWeight: '700',
});

const BenefitsListStyles = css({
	listStyle: 'none',
	paddingLeft: 0,
});

const BenefitsListItemStyles = css({
	paddingBottom: token('space.200', '16px'),
	marginTop: 0,
});
